// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"4861b750","386":"a727749c"}[chunkId] + ".chunk.js";
};